import type { IRoute } from '@/router/helpers'
import { BasicLayout } from '@/layouts'

const route: IRoute = {
  path: 'info',
  Component: BasicLayout,
  children: [
    {
      path: '',
      Component: lazy(() => import('@/views/info/index')),
      meta: { title: '新闻列表' },
    },
    {
      path: ':id',
      Component: lazy(() => import('@/views/info/detail')),
      meta: { title: '详情' },
    },
  ],
}

export default route
